module.exports = __webpack_public_path__ + "media/images/transcript-icon-e0248a7d69728959847cd12f2e4ac69f.svg";